import React, { useCallback, useEffect } from "react";
import {
  GSForm,
  GSItemInfo,
  GSSidePanelPage,
} from "golfstatus_react_components";
import {
  faChevronLeft,
  faExclamationCircle,
} from "@fortawesome/free-solid-svg-icons";
import { useMatch, useNavigate } from "react-router-dom";

//import scss
import "./tournament-copy.scss";
import { useFormDataValidation } from "../../hooks/formHooks";
import {
  useNotificationAction,
  useNotificationBanner,
} from "../../hooks/notificationHooks";
import { getCopyForm } from "../../forms/TournamentForms";
import TournamentLineItem from "../tournament-line-item";
import { useSelector, useDispatch } from "react-redux";
import {
  clearTournamentNotifications,
  copyTournament,
  getTournament,
  selectCopySettings,
  selectCurrentTournament,
  selectTournamentNotifications,
  setCopySettings,
} from "../../reducers/tournamentSlice";
import { addNotification } from "../../reducers/appSlice";

//Name the component
const TournamentCopy = (props) => {
  const copySettings = useSelector(selectCopySettings);

  const [context, isValid, setIsValid] = useFormDataValidation({
    initialValid: false,
    data: copySettings,
    setData: setCopySettings,
  });

  const match = useMatch("/tournaments/copy/:tournamentID");
  const dispatch = useDispatch();

  useEffect(() => {
    if (match?.params?.tournamentID) {
      dispatch(getTournament(match.params.tournamentID));
    }
    return () => {
      dispatch(clearTournamentNotifications());
    };
  }, [match?.params?.tournamentID, dispatch]);

  const currentTournament = useSelector(selectCurrentTournament);

  useEffect(() => {
    dispatch(
      setCopySettings({
        name: `${currentTournament?.name} (copy)`,
        copyTournamentPromotion: true,
        copyRegistrationPackages: true,
        copyPaymentSettings: true,
      })
    );
  }, [currentTournament, dispatch]);

  const navigate = useNavigate();
  const notifications = useSelector(selectTournamentNotifications);

  const redirect = useCallback(
    (notification) => {
      if ((notification?.resultPayload?.warningMessage ?? "") !== "") {
        const warn = {
          ...notification,
          timeout: 0,
          state: "warning",
          fixUrl: `/${notification?.resultPayload?.id}/rounds`,
          header: (
            <GSItemInfo
              header={"Your tournament has been copied."}
              value={notification?.resultPayload?.warningMessage}
              icon={faExclamationCircle}
            ></GSItemInfo>
          ),
        };
        dispatch(addNotification(warn));
      }
      navigate(`/${notification?.resultPayload?.id}`);
    },
    [dispatch, navigate]
  );

  useNotificationAction("created", notifications, redirect, "Copy");

  const save = () => {
    setIsValid(false);
    let updateCopySettings = { ...copySettings };
    updateCopySettings.date = new Date(
      updateCopySettings?.date
    )?.toISOString?.();
    dispatch(
      copyTournament({ ...updateCopySettings, id: match?.params?.tournamentID })
    );
  };

  const getDrawerActions = () => {
    let actions = [
      {
        name: "Save & Continue",
        isDisabled: !isValid,
        action: save,
        type: "black",
      },
      { name: "cancel", action: leftNavigation, type: "grey" },
    ];
    return actions;
  };

  const leftNavigation = () => {
    navigate(-1);
  };

  const getNavigation = () => {
    //Add Title to your component
    return {
      title: `Copy Tournament`,
      leftIcon: faChevronLeft,
      leftButtonClick: leftNavigation,
    };
  };

  const getContent = () => {
    return (
      <GSForm
        formTitle={<TournamentLineItem tournament={currentTournament} />}
        formSections={getCopyForm(context)}
      ></GSForm>
    );
  };

  const getDrawer = () => {
    return {
      actions: getDrawerActions(),
    };
  };

  const [banner] = useNotificationBanner({ notifications });

  return (
    //name the component tag
    <tournament-copy>
      <GSSidePanelPage
        header={getNavigation()}
        banner={banner}
        content={getContent()}
        drawer={getDrawer()}
      ></GSSidePanelPage>
    </tournament-copy>
  );
};

//export the new name
export default TournamentCopy;
